import { render, staticRenderFns } from "./ConfirmArea.vue?vue&type=template&id=d5d50324"
import script from "./ConfirmArea.vue?vue&type=script&lang=js"
export * from "./ConfirmArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports